import React from "react";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { getListForTable, updateStatus, clearMessages } from "redux/actions/catalogoTipoObrasActions";
import TipoObrasForm from "views/Catalogos/TipoObras/TipoObrasForm";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import FormatPaint from "@material-ui/icons/FormatPaint";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Error from "@material-ui/icons/Error";
import Add from "@material-ui/icons/Add";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import Snackbar from "components/Snackbar/Snackbar.js";

import styles from "assets/jss/material-dashboard-pro-react/views/recordsListStyle.js";

const useStyles = makeStyles(styles);

function TipoObrasList(props) {
    const [showList, setShowList] = React.useState(true);
    const [recordId, setRecordId] = React.useState(0);
    const [listData, setListData] = React.useState(null);
    const [confirmDialog, setConfirmDialog] = React.useState(null);

    const { loading, error } = props;    

    // component did mount
    React.useEffect(() => {
        props.getList();
    }, []);

    // when prop.list change
    React.useEffect(() => {
        if (props.list) {
            setListData(props.list.map((prop, key) => {
                return {
                    id: prop.Id,
                    descripcion: prop.Descripcion,
                    acciones: (
                        <div className="actions-right">
                            <Button
                                justIcon
                                round
                                simple
                                onClick={() => {
                                    const row = props.list.find(r => r.Id === prop.Id);
                                    editRecordClick(row.Id);
                                }}
                                color="info"
                                className="edit"
                            >
                                <Edit />
                            </Button>{" "}
                            <Button
                                justIcon
                                round
                                simple
                                onClick={() => {
                                    const row = props.list.find(r => r.Id === prop.Id);
                                    deleteRecordClick(row.Id);
                                }}
                                color="danger"
                                className="remove"
                            >
                                <Close />
                            </Button>{" "}
                        </div>
                    )
                };
            }));
        }
    }, [props.list]);

    // when prop.reloadList change
    React.useEffect(() => {
        if(props.reloadList){
            setConfirmDialog(null);
            props.getList();
        }        
    }, [props.reloadList]);

    const editRecordClick = id => {
        setRecordId(id);
        setShowList(false);
    };

    const deleteRecordClick = id => {
        setConfirmDialog(
            <SweetAlert
              warning
              style={{ display: "block", marginTop: "-100px" }}
              title="Estas seguro de eliminar el registro?"
              onConfirm={() => props.updateStatus(id, 0)}
              onCancel={() => setConfirmDialog(null)}
              confirmBtnCssClass={classes.button + " " + classes.success}
              cancelBtnCssClass={classes.button + " " + classes.danger}
              confirmBtnText="Aceptar"
              cancelBtnText="Cancelar"
              showCancel
            />
          );                
    };

    const reactTable = listData ? (
        <ReactTable
            columns={[
                {
                    Header: "Descripcion",
                    accessor: "descripcion"
                },
                {
                    Header: "Acciones",
                    accessor: "acciones"
                }
            ]}
            data={listData}
        />
    ) : loading;

    const addButtonClick = () => {
        setRecordId(0);
        setShowList(false);
    }

    const returnToList = () => {
        setShowList(true);
        props.scrollToTop();    
    }

    const form = <TipoObrasForm recordId={recordId} returnToList={returnToList}/>;    

    const errorNotification = error ? (
        <Snackbar
          place="tc"
          color="danger"
          icon={Error}
          message={error}
          open
          closeNotification={() => props.clearMessages()}
          close
        />
      ) : null;    

    const classes = useStyles();    

    return (
        <GridContainer>
            {confirmDialog}
            {errorNotification}         
            <GridItem xs={12} style={{ textAlign: "right" }}>
                <Button color="info" size="sm" className={classes.marginRight} onClick={addButtonClick}>
                    <Add className={classes.icons} /> Agregar
                </Button>                
            </GridItem>             
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="info" icon>
                        <CardIcon color="info">
                            <FormatPaint />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>{showList ? "Listado de registros" : "Captura de información"}</h4>
                    </CardHeader>
                    <CardBody>
                        {showList ? reactTable : form}
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );
}

const mapStateToProps = (state) => {
    return {
        list: state.catalogoTipoObras.genericList,
        reloadList: state.catalogoTipoObras.reloadList,
        error: state.catalogoTipoObras.listError,
        loading: state.catalogoTipoObras.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getList: () => dispatch(getListForTable()),
        updateStatus: (id, status) => dispatch(updateStatus(id, status)),
        clearMessages: () => dispatch(clearMessages()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TipoObrasList);